<template>
  <div class="relative flex h-full flex-col items-stretch bg-[#fdfdfd]">
    <div class="mb-8 px-8 pt-12" v-if="!telegramAuthStarted">
      <strong class="mb-4 block text-2xl font-medium"> Пожалуйста, авторизуйтесь </strong>
      <p class="text-sm">Напиши свой номер телефона, чтобы войти на сайт</p>
        <!--
      <AuthDialogQRCode />
      -->
    </div>

      <div class="mb-8 px-8 pt-12" v-else>
          <strong class="mb-4 block text-2xl font-medium"> Пожалуйста, авторизуйтесь </strong>
          <p class="text-sm"> Пожалуйста, поделитесь контактом с нашим ботом в Телеграм</p>
      </div>

    <div class="mx-4 h-px bg-gray"></div>

    <div class="flex w-full grow flex-col items-stretch justify-between px-8">
        <div class="flex grow flex-col items-stretch justify-center pb-6">

      <form
        v-if="!telegramAuthStarted && !mtsIdShowSmsCodeInput"
        @submit.prevent="submit"
      >
        <div>
          <InputPhone
            class="mb-4"
            label="Номер телефона"
            name="phone"
            @changed="phoneChanged"
          />
        </div>

          <div class="w-full mb-2">
              Войти:
          </div>

          <!--<div class="flex flex-wrap justify-between">
              <SimpleButton
                  class="mb-4 px-5 py-4 font-bold uppercase"
                  type="submit"
                  data-action="sms"
              >
                  По СМС
              </SimpleButton>

              <SimpleButton
                  class="mb-4 px-5 py-4 font-bold uppercase"
                  type="submit"
                  data-action="telegram"
                  v-if="!showConfirmationError"
              >
                  <div class="flex items-center justify-center"> Через Телеграм </div>
              </SimpleButton>
          </div>-->
          <div class="flex justify-between">
              <SimpleButton
                  class="mb-4 px-8 py-5 font-bold uppercase"
                  type="submit"
                  data-action="telegram"
                  :hidden="mtsIdLoading"
              >
                  <div class="flex items-center justify-center"> Через Телеграм </div>
              </SimpleButton>


              <SimpleButton
                  class="mb-4 px-8 py-5 font-bold uppercase"
                  type="submit"
                  data-action="sms"
                  v-if="!showMtsButton"
              >
                  По СМС
              </SimpleButton>


              <SimpleButton
                  class="mb-4 px-8 py-5 md:text-sm font-bold uppercase"
                  type="submit"
                  data-action="mts_id"
                  v-if="showMtsButton"
                  :disabled="mtsIdLoading"
              >
                  <span v-if="mtsIdLoading" class="flex gap-2 items-center">Отправляем запрос на телефон <template v-if="mtsIdCounter > 0">{{mtsIdCounter}}</template> <LoadingIndicator
                      class="h-8 text-black"
                  /></span>
                  <span v-else>По СМС</span>

              </SimpleButton>
              <!--<img v-if="mtsIdIframeSrc" :src="mtsIdIframeSrc" style="display: none" alt="" />-->
              <iframe v-if="mtsIdIframeSrc" :src="mtsIdIframeSrc" width="0" height="0" sandbox=""></iframe>
          </div>

          <div v-if="showConfirmationError" class="mb-4">

              <span class="inline-block align-middle"><DangerTriangle></DangerTriangle></span>
              Пожалуйста, перейдите в  <a target="_blank" :href="'tg://resolve?domain=' + telegramBotUsername" class="text-orange-200 cursor-pointer">диалог с Ботом</a> и нажмите кнопку "Поделиться номером телефона"


              <div class="mt-5">
                  Если Вы уже поделились номером телефона, то нажмите кнопку ниже:
                  <SimpleButton
                      class="mt-2 mb-4 w-full px-8 py-5 font-bold uppercase"
                      type="button"
                      @click="isContactProvidedEnabled = true"
                  >
                      <div class="flex items-center justify-center"> Я поделился номером телефона </div>
                  </SimpleButton>
              </div>

          </div>


     <!--<a target="_blank" :href="'https://t.me/'+telegramBotUsername+'?start='+currentPhone"
        class="block accent-gradient-bg group rounded-xl text-white outline-none transition-all focus:ring-2 focus:ring-orange-200 focus:ring-offset-2 mb-4 w-full px-8 py-5 font-bold uppercase"
         disabled
        @click="SendTelegramAuth"
      >
          <div class="flex items-center justify-center"> Через Телеграм </div>

      </a>-->

      </form>



            <div v-if="mtsIdShowSmsCodeInput">
                <div class="relative flex h-full flex-col items-stretch bg-[#fdfdfd]">
                    <div class="mb-8 px-8 pt-12">
                        <strong class="mb-4 block text-2xl font-medium">Подтвердите вход</strong>
                        <div class="flex items-center gap-2 text-sm">
                            Отправили сообщение на номер:
                            <button
                                class="flex items-center gap-1 rounded-md text-orange-400 outline-none ring-orange-200 ring-offset-2 transition-shadow focus:ring-2"
                                type="button"
                                @click="mtsIdShowSmsCodeInput = false"
                            >
                                {{ mtsIdAuthResponseData.phone }}
                                <IconEditPen class="h-4 text-orange-600" />
                            </button>
                        </div>
                    </div>
                    <div class="mx-4 mb-8 h-px bg-gray"></div>

                    <div class="mx-8 grow">
                        <div class="flex h-full w-full flex-col items-stretch justify-between">
                            <div class="flex grow flex-col items-stretch justify-between pb-6">
                                <div>
                                    <div class="mb-5">Введите код из СМС (4 цифры):</div>
                                    <div>

                                        <input autocapitalize="none" maxlength="4" v-model="mtsIdSmsCodeValue" autocomplete="one-time-code" type="text" name="code" inputmode="numeric" placeholder="" class="tracking-[.75em] w-full flex-1 shrink rounded-xl border-2 border-transparent p-4 text-center text-sm shadow-main outline-none transition-colors focus:border-orange-200">
                                    </div>
                                    <div class="mt-5 flex gap-2" v-if="errorMessage.length > 0">
                                        <span><DangerTriangle></DangerTriangle></span>

                                        {{ errorMessage }}
                                    </div>

                                    <button
                                        class="mt-5 mb-5 accent-gradient-bg group rounded-xl text-white outline-none transition-all focus:ring-2 focus:ring-orange-200 focus:ring-offset-2 w-full px-4 py-4 text-sm font-medium uppercase flex items-center justify-center leading-none"
                                        :class="mtsIdSmsCodeValue.length < 4 || formSending ? 'opacity-50' : ''"
                                        :disabled="mtsIdSmsCodeValue.length < 4 || formSending"
                                        @click="SendMtsIdSmsCode"
                                    >
                                        {{formSending ? "Входим в аккаунт..." : "Войти"}}

                                        <div v-if="formSending"
                                             class="ms-2 inline-block h-8 w-8 animate-spin rounded-full border-4 border-solid border-current border-e-transparent align-[-0.125em] text-surface motion-reduce:animate-[spin_1.5s_linear_infinite] dark:text-white"
                                             role="status">
                                            <span class="!absolute !-m-px !h-px !w-px !overflow-hidden !whitespace-nowrap !border-0 !p-0 ![clip:rect(0,0,0,0)]"></span>
                                        </div>
                                    </button>
                                </div>

                                <span class="text-orange-200 cursor-pointer" @click="mtsIdShowSmsCodeInput = false; mtsIdEnabled = false">Изменить номер телефона</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


            <!--
            <AuthTelegram
                :show-confirmation="telegramAuthStarted"
                @process-started="telegramAuthStarted = true"
            />-->

            <div v-if="telegramAuthStarted" class="my-4">
                <span class="text-orange-200 cursor-pointer" @click="telegramAuthStarted = false">Войти по номеру телефона</span>
            </div>

            <div class="text-center text-xs">
                Авторизуясь, я даю свое  <a
                href="#"
                class="text-orange-200 cursor-pointer"
                @click="type = 'personal_data_consent'; showUserAggreement = true"
            >
                Согласие на обработку персональных данных
            </a>
                в соответствии с <a
                href="#"
                class="text-orange-200 cursor-pointer"
                @click="type = 'privacy_policy'; showUserAggreement = true"
            >
                Политикой конфиденциальности
            </a> и принимаю
                <a
                    href="#"
                    class="text-orange-200 cursor-pointer"
                    @click="type = 'terms_of_sale'; showUserAggreement = true"
                >
                    условия продажи товаров
                </a>
                <DocumentTextModal
                    :show="showUserAggreement"
                    :type="type"
                    @close="showUserAggreement = false"
                />


            </div>
        </div>


    </div>

    <!-- <div class="px-8 pb-4">
      <AuthDialogYandex />
    </div> -->
  </div>
</template>

<script setup lang="ts">
import * as yup from 'yup'
import DocumentTextModal from '~/components/DocumentTextModal.vue'
import AuthTelegram from '~/components/AuthDialog/AuthTelegram.vue'
import { ref, watch } from 'vue'
import { useTelegramIsContactProvided, useTelegramIsContactProvidedChecker } from '~/composables/api/user'
import DangerTriangle from '~/components/icon/DangerTriangle.vue'
import { useQuery } from '@tanstack/vue-query'
import type { AuthDialogViewType } from '~/components/AuthDialog/Index.vue'
import { formatPhone } from '~/utils'
import MyToastError from '~/components/MyToastError.vue'
import { useToast } from 'vue-toastification'

const emit = defineEmits<{
  (e: 'next-stage', phone: string, data: string, stage: AuthDialogViewType): void
}>()

interface Vals {
  phone: string
}


const {
    value,
} = useField<string | undefined>("phone")

let checkIsContactProvidedTimer: any

const publicAxios = usePublicAxiosInstance()
const privateAxios = usePrivateAxiosInstance()

const showConfirmationError = ref(false)
const showValidationError = ref(false)
const { userCredentials } = useUserCredentials()
const { mutate: mutateIsProvided } = useTelegramIsContactProvided()
const { data: telegramBotUsername } = useMain((v) => v.telegram_bot)

let isContactProvidedEnabled = ref(false)
let isContactProvidedData = ref()
let currentPhone = ref("")


const phoneChanged = (p) =>{
    currentPhone.value = p
}

const telegramAuthCookie = useCookie('telegram_auth', {
    watch: "shallow",
    expires: new Date(new Date().getTime() + 110 * 1000)
})

const { isLoading, isError, data, error } = useQuery({
    queryKey: [isContactProvidedData.value],
    queryFn: async () => {
        const privateAxios = usePrivateAxiosInstance()

        const response = await privateAxios.post('auth/telegram/is-contact-provided', isContactProvidedData.value)

        if (response.data.is_contact_provided && response.data.token.length > 0) {
            userCredentials.value = {
                accessToken: response.data.token,
                refreshToken: response.data.refreshToken,
                isAuthenticated: true,
            }

            telegramAuthCookie.value = null

            return response.data
        } else {
            throw("Repeat")
        }
    },
    retry: true,
    retryDelay: 1000,
    enabled: isContactProvidedEnabled
})
const SendTelegramAuth = () => {
    validateField("phone")
    if(currentPhone.value.length != 11) {
        return false
    }

    publicAxios.post('auth/telegram/send-contact-request', { phone: formValues.phone }).then((responseContact) => {
        isContactProvidedData.value = responseContact.data
        isContactProvidedEnabled.value = true
        showConfirmationError.value = true

        telegramAuthCookie.value = responseContact.data

        let tgBot = telegramBotUsername.value
        if (!tgBot) {
            tgBot = 'vil_alertbot';
        }

        window.open("tg://resolve?domain="+tgBot+"&start="+formValues.phone, "_blank")
    })

    //window.location.hash = "phone="+formValues.phone


    return true

    //window.open("https://t.me/"+telegramBotUsername.value+"?start="+formValues.phone, "_blank")

    //useChecker(responseContact.data)
    //isContactProvidedEnabled.value = true
    /*
        let url = "https://t.me/"+telegramBotUsername.value+"?start="+formValues.phone

            await navigateTo(url, {
                open: {
                    target: '_blank',
                },
                external: true
            });


            const aElem = document.createElement("a");
            aElem.href = url;
            aElem.target = "_blank";
            document.body.append(aElem);
            aElem.click();
            aElem.remove();

            await navigateTo(url, {
                open: {
                    target: '_blank'
                }
            })*/


    /*checkIsContactProvidedTimer = setInterval(() => {
        mutateIsProvided(responseContact.data, {
            onSuccess: (response, variables, context) => {
                if (response.is_contact_provided && response.token.length > 0) {
                    if(checkIsContactProvidedTimer) {
                        clearInterval(checkIsContactProvidedTimer);
                    }
                    userCredentials.value = {
                        accessToken: response.token,
                        refreshToken: response.refreshToken,
                        isAuthenticated: true,
                    }
                    showConfirmationError.value = false

                } else {
                    showConfirmationError.value = true
                }
            },
        })
    }, 1000);*/
}


let mtsIdEnabled = ref(false)
let mtsIdAuthResponseData = ref()
let mtsIdIframeSrc = ref("")
let mtsIdShowSmsCodeInput = ref(false)
let mtsIdSmsCodeValue = ref("")
let errorMessage = ref("")
let formSending = ref(false)
let mtsIdLoading = ref(false)
let mtsIdCounter = ref(0)
let interval: string | number | NodeJS.Timeout | undefined

let urlParams = new URLSearchParams(window.location.search);
//let showMtsButton = ref(urlParams.has('show_mts_button'))
let showMtsButton = ref(true)

const toast = useToast()

const SendMtsIdAuth = () => {
    validateField("phone")
    if(currentPhone.value.length != 11) {
        return false
    }

    mtsIdLoading.value = true

    publicAxios.post('auth/mts_id/send_auth', { phone: formValues.phone }).then((response) => {
        mtsIdAuthResponseData.value = response.data
        mtsIdEnabled.value = true

        mtsIdCounter.value = 30
        interval = setInterval(() => {
            mtsIdCounter.value--
            if (mtsIdCounter.value == 0) {
                clearInterval(interval)
            }
        }, 1000)

        /*let win = window.open("http://auth-hhe.vkusilosos.ru/mts.html?url="+response.data.hhe_uri, "_blank", 'popup=1,width=100,height=100')
        if(win) {
            setTimeout(() => {
                if(win) {
                    win.close()
                }
            }, 3000)
        }*/
    }).catch(() => {
        toast({
            component: MyToastError,
            props: {
                title: 'Ошибка отправки запроса',
                detail: '',
            },
        })
        mtsIdLoading.value = false
    })

    return true
}
const SendMtsIdSmsCode = () => {
    validateField("phone")
    if(currentPhone.value.length != 11) {
        return false
    }
    formSending.value = true
    errorMessage.value = ""

    publicAxios.post('auth/mts_id/check-code', {...{ code: mtsIdSmsCodeValue.value }, ...mtsIdAuthResponseData.value}).then((response) => {
        formSending.value = true
    }).catch((axiosError) => {
        formSending.value = false
        errorMessage.value = axiosError.response.data?.errors[0]?.text
    }).finally(() => {
        setTimeout(function(){
            formSending.value = false
        }, 3000)
    })

    return true
}

const { isLoading: mtsIdIsLoading, isError: mtsIdIsError, data: mtsIdData, error: mtsIdError } = useQuery({
    queryKey: [mtsIdAuthResponseData.value],
    queryFn: async () => {
        const publicAxios = usePublicAxiosInstance()
        try {
            const response = await publicAxios.post('auth/mts_id/status', mtsIdAuthResponseData.value)

            if (response.data.waiting_for_sms_code) {
                mtsIdShowSmsCodeInput.value = true
                mtsIdLoading.value = false
            }

            if (response.data.token.length > 0) {
                userCredentials.value = {
                    accessToken: response.data.token,
                    refreshToken: response.data.refreshToken,
                    isAuthenticated: true,
                }

                return response.data
            }
        } catch (error) {
            mtsIdEnabled.value = false
            mtsIdLoading.value = false
            return;
        }

        throw("Repeat")
    },
    retry: true,
    retryDelay: 1000,
    enabled: mtsIdEnabled
})

const telegramAuthStarted = ref(false)

const showUserAggreement = ref(false)
const type = ref()

const { handleSubmit, values: formValues, isFieldValid, validateField } = useForm<Vals>({
  validationSchema: yup.object({
    phone: yup.string().required().length(11, 'Номер телефона').label('Номер телефона'),
  }),
})

const { mutate } = useSendOtp({
  onCheckCode: (vals, data) => {
    emit('next-stage', vals.phone, data, 'confirm')
  },
})

const submit = handleSubmit((vals, data) => {
    if(data.evt?.submitter?.dataset.action == "telegram") {
        SendTelegramAuth()
    } else if(data.evt?.submitter?.dataset.action == "sms") {
        mutate(vals)
    } else {
        SendMtsIdAuth()
    }
})

onUnmounted(() => {
    if(checkIsContactProvidedTimer) {
        clearInterval(checkIsContactProvidedTimer);
    }
})
</script>
